import { onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';

export const useCaptainOperationContext = () => {
  const route = useRoute();
  let active = true;
  onBeforeUnmount(() => {
    active = false;
  });
  const key = () =>
    JSON.stringify([
      route.params.accountId,
      route.params.assistantId,
      route.fullPath,
    ]);
  return () => {
    const initial = key();
    return () => active && key() === initial;
  };
};
